import { render, staticRenderFns } from "./k-search-panel.vue?vue&type=template&id=5a163d10&scoped=true"
import script from "./k-search-panel.vue?vue&type=script&lang=js"
export * from "./k-search-panel.vue?vue&type=script&lang=js"
import style0 from "./k-search-panel.vue?vue&type=style&index=0&id=5a163d10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a163d10",
  null
  
)

export default component.exports